import TiersListInput from "./TiersListInput";

export default TiersListInput;
